import { WOOTDASH_BASE, wootdashAuthHeaders } from '@/api/wootdash'

// POST /anexos — multipart, sem Content-Type manual (o browser define o boundary).
// Devolve um caminho relativo (ver LocalFileMediaStorage) — usar toMediaUrl() pra exibir.
// mediaMimeType vem do backend (data.mimeType) — precisa ir junto no envio da mensagem
// (sendMessage) pra o ConvDrawer saber renderizar imagem/áudio/vídeo/pdf corretamente. O mime pode voltar
// diferente do arquivo: áudio/vídeo gravado em WebM é convertido (OGG/MP4) pra o WhatsApp aceitar.
// mediaFileName = nome original, que o contato vê quando o anexo chega como documento.
export const MAX_ATTACHMENT_BYTES = 25 * 1024 * 1024

export async function uploadAttachment(token: string, file: File): Promise<{ mediaUrl: string; mediaMimeType: string; mediaFileName: string } | null> {
  const form = new FormData()
  form.append('arquivo', file)
  try {
    const res = await fetch(`${WOOTDASH_BASE}/anexos`, {
      method: 'POST',
      headers: wootdashAuthHeaders(token),
      body: form,
    })
    if (!res.ok) return null
    const data = await res.json()
    return { mediaUrl: data.mediaUrl, mediaMimeType: data.mimeType, mediaFileName: file.name }
  } catch {
    return null
  }
}
